/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 発注業務可能フラグ（水曜日）
 * @export
 * @interface EnableOrderdayWed
 */
export interface EnableOrderdayWed {
}

/**
 * Check if a given object implements the EnableOrderdayWed interface.
 */
export function instanceOfEnableOrderdayWed(value: object): value is EnableOrderdayWed {
    return true;
}

export function EnableOrderdayWedFromJSON(json: any): EnableOrderdayWed {
    return EnableOrderdayWedFromJSONTyped(json, false);
}

export function EnableOrderdayWedFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnableOrderdayWed {
    return json;
}

export function EnableOrderdayWedToJSON(json: any): EnableOrderdayWed {
    return EnableOrderdayWedToJSONTyped(json, false);
}

export function EnableOrderdayWedToJSONTyped(value?: EnableOrderdayWed | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

